import { GatewayAssujetti, GatewayConformite } from "@conformite/gateway";
import { AssujettiParcoursConformiteEnum } from "./AssujettiPaneContent/pages/AssujettiParcoursConformite/AssujettiParcoursConformite";

export const AxeConformiteAssujettiLabels: Record<
  GatewayConformite.AxeConformiteAssujetti,
  string
> = {
  [GatewayConformite.AxeConformiteAssujetti.HONORABILITE]: "Honorabilité",
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IAS]:
    "Capacité professionnelle IAS",
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IOBSP]:
    "Capacité professionnelle IOBSP",
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IAS]:
    "Formation continue IAS",
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IOBSP]:
    "Formation continue IOBSP",
};

export const axeToStep: Partial<
  Record<
    GatewayConformite.AxeConformiteAssujetti,
    AssujettiParcoursConformiteEnum
  >
> = {
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IAS]:
    AssujettiParcoursConformiteEnum.CAPACITE_PRO_IAS,
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IOBSP]:
    AssujettiParcoursConformiteEnum.CAPACITE_PRO_IOBSP,
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IAS]:
    AssujettiParcoursConformiteEnum.FORMATION_CONTINUE_IAS,
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IOBSP]:
    AssujettiParcoursConformiteEnum.FORMATION_CONTINUE_IOBSP,
};

export const axeToAvancementField: Record<
  string,
  keyof Omit<GatewayAssujetti.Avancement, "idAssujetti" | "millesime">
> = {
  [GatewayConformite.AxeConformiteAssujetti.HONORABILITE]: "honorabilite",
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IAS]:
    "formationContinueIas",
  [GatewayConformite.AxeConformiteAssujetti.FORMATION_CONTINUE_IOBSP]:
    "formationContinueIobsp",
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IAS]:
    "capaciteProfessionnelleIas",
  [GatewayConformite.AxeConformiteAssujetti.CAPACITE_PRO_IOBSP]:
    "capaciteProfessionnelleIobsp",
};

export const RoleAssujettiLabels: Record<
  GatewayAssujetti.RoleAssujetti,
  string
> = {
  REPRESENTANT_LEGAL: "Représentant légal de la structure",
  ASSOCIE: "Associé",
  DIRECTEUR_GENERAL: "Directeur général",
  DIRECTEUR_ADMINISTRATIF: "Directeur/responsable Administratif",
  DIRECTEUR_CONFORMITE: "Directeur conformité/juridique",
  DIRECTEUR_MARKETING: "Directeur Marketing / Communication",
  DIRECTEUR_COMMERCIAL: "Directeur/Responsable commercial",
  CHARGE_CLIENTELE: "Chargé de clientèle",
  JURISTE: "Souscripteur/juriste",
  GESTIONNAIRE: "Gestionnaire",
  CHEF_DE_PROJET: "Chef de projet",
  RESPONSABLE_BUREAU: "Responsable de bureau",
  COMMERCE: "Commerce",
  GESTION: "Gestion",
  BACK_OFFICE: "Back office",
} as const;
